// extracted by mini-css-extract-plugin
export default {"product-carousel":"product-carousel_BtyDJunI"};